import { useMemo } from "react";
import uuid from "../../../utils/uuid";

const QTcAlgtypeEditor = ({ QTcAlg, QTcAvailableAlgs, onChanged, loc }) => {
    const QTcAlgTypeID = "edit.qtcalgtype";

    const algs = useMemo(() => {
        const algDisplayNames = {
            Bazett: "Bazett",
            Fridericia: "Fridericia",
            Framingham: "Framingham",
            MortaraVeritas: "Mortara Veritas",
            Hodges: "Hodges"
        };
        if (!QTcAvailableAlgs?.length) {
            const key = "Bazett";
            return [[key, algDisplayNames[key]]];
        }
        return QTcAvailableAlgs.map(alg => [alg, algDisplayNames[alg]]);
    }, [QTcAvailableAlgs]);

    const options = useMemo(
        () =>
            algs?.map(v => (
                <option value={v[0]} key={uuid()}>
                    {v[1]}
                </option>
            )) || [],
        [algs]
    );
    const defaultValue = useMemo(() => algs[0][0], [algs]);
    const disabled = useMemo(() => !(QTcAlg && QTcAvailableAlgs?.length), [QTcAlg, QTcAvailableAlgs]);
    return (
        <div className="ctrl-input-group">
            <label className="qtc-algtype-label" htmlFor={QTcAlgTypeID}>
                {loc("report.params.QTcAlgType")}
            </label>
            <select
                id={QTcAlgTypeID}
                disabled={disabled}
                className="ctrl-input ctrl-input-QTcAlg"
                value={QTcAlg || defaultValue}
                onChange={e => {
                    onChanged(QTcAlgTypeID, { QTcAlg: e.target.value });
                }}>
                {options}
            </select>
        </div>
    );
};

export default QTcAlgtypeEditor;
